import { render, staticRenderFns } from "./EditAlert.vue?vue&type=template&id=052100a6"
import script from "./EditAlert.vue?vue&type=script&lang=js"
export * from "./EditAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports